import * as Tone from 'tone'

var TaikoAudio = {
  mainSoundBuffer: null,
  taikoHitSample: "Taiko Drum 4.flac",
  audioLoaded: false,
  masterLimiterNode: null,
  Tone: Tone,
  lastStrokeGainNode: null,
  staticFilesPath: "",

  createBufferSource: function(buffer) {
    return new Promise( (resolve, reject) => {
      var bufferSource = new Tone.BufferSource(buffer)
      if( bufferSource.buffer.duration !== undefined && bufferSource.buffer.duration != null && bufferSource.buffer.duration > 0 ){
        bufferSource.toMaster()
        resolve(bufferSource)
      } else {
        reject(new Error("Failed to load buffer into bufferSource"))
      }
    })
  },

  enable: async function(){
    try {
      await Tone.start()
    } catch (error){
      return error
    }

    Tone.context.latencyHint = 'fastest'
    Tone.context.lookAhead = 0.001

    this.masterLimiterNode = new Tone.Limiter(-3).toMaster()
    this.mainSoundBuffer = new Tone.Buffer(this.staticFilesPath + '/samples/' + this.taikoHitSample, () => {
      console.log("loaded drum sample: " + this.taikoHitSample)
      this.audioLoaded = true

      let test = new Tone.BufferSource(this.mainSoundBuffer)
      .connect(this.masterLimiterNode)
      .start()
    })
  },
  
  playTaikoHit: function(gain){
    this.lastStrokeGainNode = new Tone.Gain(gain).connect(this.masterLimiterNode)
    const bufferSource = new Tone.BufferSource(this.mainSoundBuffer)
      .connect(this.lastStrokeGainNode)
      .start()
  },

  updateGainOnLastStroke: function(updatedGain){
    if(this.lastStrokeGainNode){
      this.lastStrokeGainNode.gain.exponentialRampTo(updatedGain, 1/120)
    }
  }
}

export { TaikoAudio }